import Vue from 'vue'
import store from '../stores'

const pipe = {
    NUMBER: function(event) {
        let keyCode = event.keyCode
        if (keyCode < 48 || keyCode > 57) {
            event.preventDefault()
        }
    },
    DOUBLE: function(event) {
        event = (event) ? event : window.event
        let isPoint = event.srcElement.value.includes('.')
        let isResta = event.srcElement.value.includes('-')
        var charCode = (event.which) ? event.which : event.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
            event.preventDefault()
        } else {
            if(isPoint && event.key == '.'){
                event.preventDefault()
            }if(isResta && event.key == '-'){
                event.preventDefault()
            }if(event.srcElement.value != '' && event.key == '-'){
                event.preventDefault()
            }else{
                return true
            }
        }
    },
    DOUBLE_OPERATOR: function(event) {
        event = (event) ? event : window.event
        var charCode = (event.which) ? event.which : event.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45 && charCode !== 43 && charCode !== 43 && charCode !== 42 && charCode !== 42 && charCode !== 47 && charCode !== 47) {
            event.preventDefault()
        } else {
            return true
        }
    },
    DATE: function(value) {
      return moment(String(value)).format('DD/MM/YYYY')
    },
    DATETIME: function(value) {
      return moment(String(value)).format('DD/MM/YYYY hh:mm:ss')
    },
    SIZE: function(value){
        var _size = value;
        var fSExt = new Array('Bytes', 'KB', 'MB', 'GB'),
        i=0;while(_size>900){_size/=1024;i++;}
        var exactSize = (Math.round(_size*100)/100)+' '+fSExt[i];
        return exactSize
    },
    EXEMPTION: function(value){
        if(value == 'requested'){
            return 'Solicitada'
        }else if(value == 'documents'){
            return 'Revisión de documentos'
        }else if(value == 'preapproved'){
            return 'Pre-Aprobada'
        }else{
            return 'Aprobada'
        }
    },
    EXEMPTION_COLOR: function(value){
        if(value == 'requested'){
            return 'btn-primary'
        }else{
            return 'btn-success'
        }
    },
    EXEMPTION_PREVIEW: function(value){
        if(value == 'requested'){
            return 'Revisión de documentos'
        }else if(value == 'documents'){
            return 'Pre-Aprobar'
        }else if(value == 'preapproved'){
            return 'Aprobar'
        }
    },
    TIPODOCUMENTO: function(value){
        if(value == '01'){
            return 'Factura electrónica'
        }else if(value == '02'){
            return 'Nota de débito electrónica '
        }else if(value == '03'){
            return 'Nota de crédito electrónica'
        }else if(value == '04'){
            return 'Tiquete Electronico'
        }else if(value == '05'){
            return 'Confirmación de aceptación del comprobante electrónico'
        }else if(value == '06'){
            return 'Confirmación de aceptación parcial del comprobante electrónico'
        }else if(value == '07'){
            return 'Confirmación de rechazo del comprobante electrónico'
        }else if(value == '08'){
            return 'Factura electrónica de compra'
        }else if(value == '09'){
            return 'Factura electrónica de exportación'
        }else{
            return 'Sin definir'
        }
    },
    ESTADO: function(value){
        if(value == '0'){
            return 'Error desconocido durante la ejecución del proceso'
        }else if(value == '1'){
            return 'Ejecución correcta del proceso'
        }else if(value == '2'){
            return 'Requiere la ejecución por vía de https'
        }else if(value == '3'){
            return 'Requiere que se incluya el API KEY'
        }else if(value == '4'){
            return 'Fallo en el proceso de autentificación por un API KEY incorrecto'
        }else if(value == '5'){
            return 'Solicitud invalida'
        }else if(value == '6'){
            return 'Formato de respuesta de solicitud invalido'
        }else if(value == '10'){
            return 'Datos incompletos en la solicitud'
        }else if(value == '11'){
            return 'Correo electrónico incorrecto'
        }else if(value == '12'){
            return 'Número telefónico incorrecto, solo acepta valores numéricos'
        }else if(value == '13'){
            return 'Tipo de cambio incorrecto, solo acepte valores numéricos'
        }else if(value == '14'){
            return 'El Id de la solicitud es incorrecto o no se encuentran datos relacionados con el mismo'
        }else if(value == '15'){
            return 'Valor numeral incorrecto'
        }else if(value == '16'){
            return 'El Id de cliente incluido en la solicitud no se encuentra en el sistema'
        }else if(value == '17'){
            return 'El formato de la moneda es incorrecto'
        }else if(value == '18'){
            return 'Los montos de las facturas no coinciden con los montos de los detalles correspondientes'
        }else if(value == '19'){
            return 'El número de factura incluido en la solicitud no se encuentra en el sistema'
        }else if(value == '20'){
            return 'El tipo de pago indicado no es el correcto'
        }else if(value == '21'){
            return 'El monto de pago indicado es superior al monto de la factura'
        }else if(value == '22'){
            return 'No se encuentra compañía ligada al correo electrónico'
        }else if(value == '23'){
            return 'URL Incorrecta'
        }else if(value == '24'){
            return 'Numero de versión de Factura Electrónica incorrecto'
        }else if(value == '25'){
            return 'Nombre del método incorrecto'
        }else if(value == '26'){
            return 'Ambiente incorrecto'
        }else if(value == '27'){
            return 'Error en el XML'
        }else if(value == '28'){
            return 'Error en la validación del XML'
        }else if(value == '29'){
            return 'Numero de documento utilizado previamente'
        }else if(value == '30'){
            return 'Error en la firma del documento'
        }else if(value == '31'){
            return 'Error en el logueo con Dirección General de Tributación'
        }else if(value == '32'){
            return 'Error en la presentación del documento ante la Dirección General de Tributación'
        }else if(value == '33'){
            return 'Documento consultado no encontrado'
        }else if(value == '34'){
            return 'Estructura de JSON inválida'
        }else if(value == '35'){
            return 'Se requiere actualizar información del usuario (usuario o clave en la DGT)'
        }else if(value == '36'){
            return 'Pendiente confirmación de aceptación - rechazo, pendiente por parte de la DGT'
        }else if(value == '37'){
            return 'Verificar la fecha del documento'
        }else if(value == '38'){
            return 'Los correos son inválidos o debe separar los correos con punto y coma (;)'
        }else if(value == '39'){
            return 'Clave del documento inválido o no corresponde al emisor'
        }else if(value == '40'){
            return 'No se puede enviar, el documento se encuentra rechazado por la DGT'
        }else if(value == '41'){
            return 'Revisar los parámetros y los valores enviados'
        }else if(value == '42'){
            return 'Verificar la lista de IP habilitadas para la presentación de documentos'
        }else if(value == '43'){
            return 'Verificar la información del documento enviado, la clave del documento ya se encuentra registrada'
        }else if(value == '44'){
            return 'Verificar la información del documento enviado, el número de consecutivo ya se encuentra registrado'
        }else if(value == '45'){
            return 'Se ha presentado un error al procesar el documento, favor verificar parámetros del ATV'
        }else if(value == '46'){
            return 'El documento se encuentra pendiente de presentación'
        }else if(value == '47'){
            return 'Según instrucciones de la DGT se debe dar el plazo de 3 horas para consultar el documento'
        }else if(value == '48'){
            return 'Según fecha de vencimiento determinada por el Ministerio de Hacienda para el certificado (llave criptográfica), este ya se encuentra expirado'
        }else{
            return 'Ambiente incorrecto'
        }
    },
}

Vue.prototype.BASE = process.env.BASE
Vue.prototype.NUMBER = pipe.NUMBER
Vue.prototype.DOUBLE = pipe.DOUBLE
Vue.prototype.DOUBLE_OPERATOR = pipe.DOUBLE_OPERATOR

Vue.filter('DATE', pipe.DATE)
Vue.filter('DATETIME', pipe.DATETIME)
Vue.filter('SIZE', pipe.SIZE)
Vue.filter('EXEMPTION', pipe.EXEMPTION)
Vue.filter('EXEMPTION_COLOR', pipe.EXEMPTION_COLOR)
Vue.filter('EXEMPTION_PREVIEW', pipe.EXEMPTION_PREVIEW)
Vue.filter('ESTADO', pipe.ESTADO)
Vue.filter('TIPODOCUMENTO', pipe.TIPODOCUMENTO)

const MyPlugin = {
    install(Vue, options) {
        Vue.prototype.globalViewOption = (path) => {
            const permissions = store.state.permissions
            return permissions.findIndex((e) => { return e.route == path || (!Array.isArray(e.items) ? -1 : e.items.findIndex((i) => { return i.route == path }) !== -1) }) !== -1
        }
    },
}
Vue.use(MyPlugin)

export default pipe